module.exports = __webpack_public_path__ + "static/TNM100___UPG2-ffd8de7b653ca0c2df73251e7d7c5857.pdf";